export default {
  logout: '退出登录',
  permission_application: '权限申请',
  dbh_country: '国家',
  dbh_cascader_select_placeholder: '请选择',
  dbh_cascader_select_first_level_title: '一级分类',
  dbh_cascader_select_second_level_title: '二级分类',
  dbh_cascader_select_overall_title: '聚合数据',
  dbh_region_cascader_select_placeholder: '请选择国家',
  dbh_region_cascader_select_region: '地区',
  dbh_region_cascader_select_multi_country: '前往多国家页面',
  dbh_confirm: '确定',
  dbh_cancel: '取消',
  dbh_save_img: '图片另存为',
  dbh_copy_img: '复制图片',
  dbh_network_error_msg: '网络异常',
  dbh_compress_image_error_msg: '图片压缩异常',
  dbh_unknow_error_msg: '未知异常',
  dhh_back_old_version: '返回旧版',
  dhh_nav_bubble_dashboard_intro: '经分：查看自己游戏的数据表现。这些数据来自游戏数据上报，数据准确无误。',
  dhh_nav_bubble_benchmark_intro: '行业基准：查看行业Benchmark基准数据。',
  dhh_nav_bubble_intelligence_intro:
    '情报：查看竞品、行业数据和游戏趋势。数据来自外部数据源，可能与实际数据存在一定偏差。',
  dhh_nav_bubble_intelligence: '情报新视觉设计中，点击跳转至老版本',
  dhh_nav_bubble_opinions_intro: '舆情：查看自己游戏和竞品的舆情反馈。',
  dhh_nav_bubble_opinions: '舆情新视觉设计中，点击跳转至老版本',
  dhh_nav_bubble_globalpedia_intro: 'GPOP：线上化经营管理、战略、Pipeline、Studio管理、财务等信息呈现和工作流处理。',
  dhh_nav_bubble_globalpedia: '管理看板新视觉设计中，点击跳转至老版本',
  dhh_nav_bubble_chatgpt: 'ChatGPT-IEGG，由IEGG ADG NLP团队提供。任何反馈欢迎联系Masonqliu或Bruceang。',
  db_loading: '加载中...',

  dbh_recommendation_nolonger_displayed: '不再显示此推荐内容',
  dbh_home_new_reports: '最新报告',
  dbh_home_top_popular_reports: '最受欢迎的报告',
  dbh_home_public_true_data: '最新真实数据分享',
  dbh_home_public_true_search_key: '搜索游戏、日期、指标、贡献者、以及所有相关内容',
  dbh_home_public_true_all_data: '真数列表',
  dbh_home_public_true_data_more: '更多',
  dbh_home_true_data_contribute: '我要分享',
  dbh_AI_error_tips: '识别失败。请再试一次。',
  dbh_all_view_true: '查看所有真数',
  dbh_AI_error_tips_overlimit: '系统繁忙！请稍后再试',
  dbh_home_true_data_once: '模糊时间',
  dbh_home_top_eye_catching_Authors: '妙笔生花榜',
  dbh_home_top_prolific_authors: '笔耕不辍榜',
  dbh_home_top_active_data_lovers: '数据达人榜',
  dbh_home_game_data_lover_leaderboard: 'DataBrain数据达人荣誉榜',
  dbh_home_report_views: '报告总阅读量',
  dbh_home_report_articles: '报告数',
  dbh_home_report_active_value: '活跃值',
  dbh_home_report_first_step: '识别搜索可能为公司，已为您自动跳转至<strong>公司搜索</strong>，点击',
  dbh_home_report_second_step: '可继续搜索游戏。',
  dbh_cancel_small: '取消',
  dbh_session_expired: '会话已过期，请刷新页面以重新加载报表。',
  dbh_table_not_complete: '对应经分报表暂未完成，敬请期待',
  // 目前现网NEW都是英文，暂不需要翻译为中文
  dbh_new: 'NEW',
  dbh_user_center: '用户中心',
  dbh_uploader_placeholder_text1: '点击此处上传或拖拽文件至此处',
  dbh_uploader_placeholder_text2: '支持文件类型：{fileTypes}，大小不超过{sizeLimit}',
  dbh_report_uploader_placeholder_desc: '支持文件类型：Word、PDF、PPT、PPTX、HTML、压缩包',
  dbh_report_uploader_placeholder_html_zip_tips: '如果您的 HTML 需要引用 JS/CSS/图片资源，建议使用压缩包上传',
  dbh_report_uploader_ai_unsupported_tips: '此文件类型暂不支持 AI 自动填写功能，请手动完成填写。',
  dbh_uploader_dragging_placeholder_text: '拖拽任意文件到此处',
  // AI Search 相关
  dbh_ai_search: 'AI搜索',
  dbh_ai_search_agent_smart_qa: 'Agent智能回答',
  dbh_ai_search_page_navigation: 'DataBrain页面智能直达',
  dbh_ai_search_agent_smart_qa_hover: 'DataBrain Agent融合经分、情报与舆情等多源数据，提供游戏及行业的综合分析与洞察',
  dbh_ai_search_page_navigation_hover: '简单描述你想要前往的DataBrain网页，点击即可前往',
  dbh_ai_search_switch_open_hover: '点击开启AI搜索，获得Agent智能回答，或智能直达DataBrain页面',
  dbh_ai_search_switch_enabled_hover: '已开启AI搜索，获得Agent智能回答，或智能直达DataBrain页面。点击关闭AI搜索',
  dbh_ai_search_switch_close_hover: '点击关闭AI搜索',
  dbh_ai_search_input_placeholder: '描述你的问题或想直达的页面，点击AI搜索即可前往',
  dbh_ai_search_input_simple_placeholder: '询问Brainy',
  dbh_ai_search_page_navigating: '正在为您智能直达该页面...',
  dbh_ai_search_page_not_found: '未找到对应的DataBrain页面，可修改您的搜索词后再次尝试。任何问题可反馈sallyxue@tencent.com。',
  dbh_ai_search_page_back_to_search: '回到搜索',
  dbh_ai_search_page_navigated: '已为您智能直达该页面',
  dbh_ai_search_page_navigated_without_filters: '已为你智能直达该页面。当前页面不支持智能选择筛选条件，需手动设置筛选条件。',
  dbh_ai_search_games: '游戏',
  dbh_not_found_title: '无法识别的链接',
  dbh_not_found_desc: '系统无法识别你输入的链接格式，请检查链接后重试。',
  authpath_error_no_report: '未获取到报表信息',
  authpath_error_no_game: '未获取到游戏信息',
  authpath_error_menu_mismatch: '未匹配到菜单',
  authpath_error_no_url: '未获取到报表URL',
  authpath_error_token_empty: '获取鉴权token失败',
  authpath_error_fetch_failed: '获取鉴权信息失败',
  dbh_pr_trend_toggle_event: '事件',
};
